export default "__VITE_ASSET__CV7VoV5s__"